export default __webpack_public_path__ + "static/media/regailator-logo-wordmark.e8ecbbb9.png";